var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.wrapper},[_c('DataTable',{attrs:{"actions":true,"data":_vm.rewardsList,"columns":_vm.tableConfig,"is-loading":_vm.isLoading,"pagination":_vm.pagination},on:{"on-page-change":_vm.pageChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }